<i18n src="@/translations/FinLexiconGlossar.json"></i18n>
<template>
  <v-col v-intersect="$nextTick(updateScrollbar)"
         v-resize="calculateGlossarListHeight"
         class="glossar-wrapper pa-0 pt-5">
    <v-row>
      <fin-autocomplete ref="autoCompleteRow"
                        :no-data-text="$t('FinLexiconGlossar.autocomplete_data_not_found')"
                        class="mb-6 mx-3"
                        clearable
                        item-name="text"
                        item-value="key"
                        :placeholder="$t('FinLexiconGlossar.autocomplete_placeholder_label')"
                        :resolver="currentLanguageEntries"
                        search-icon="icon-compare"
                        style="background-color: white;"
                        @input="val => searchSelectionChanged(val)"/>
    </v-row>

    <v-row class="mx-0" style="border-top: 1px solid white">
      <v-col class="entries-wrapper px-0">
        <v-virtual-scroll ref="glossarScroller"
                          :height="glossarListHeight"
                          :items="sortedLettersEntries"
                          item-height="38"
                          :bench="10"
                          style="overflow-x: hidden">
          <template #default="{ item }">
            <div v-if="item.spacer" class="entry"></div>
            <div v-else>
              <div class="big-letter" v-if="item.isFirstEntry ">
                {{ getFirstLetter(item.text) }}
              </div>
              <v-btn :class="['entry', 'ml-12',{'activeEntry': isActive(item.ref)}]"
                     color="white"
                     text
                     @click="setCurrentEntry(item)"
              >
                {{ item.text }}
              </v-btn>

            </div>

          </template>
        </v-virtual-scroll>

      </v-col>
    </v-row>
  </v-col>
</template>
<script>
import perfectscrollbar from "fincraft-lib-basics/src/mixins/perfectscrollbar"
import FinAutocomplete from "@/components/common/Autocomplete"

export default {
  name: 'FinLexiconGlossar',
  components: {
    FinAutocomplete,
  },
  mixins: [perfectscrollbar],
  props: {
    value: {
      type: Object
    },
    showOnlyEntry: {
      type: Boolean,
      default: true
    },
    entries: {
      type: Array
    },
    drawer: {
      type: Boolean
    }
  },
  data() {
    return {
      searchText: '',
      message: [''],
      diacriticsMap: {
        "Ü": "U",
        "ü": "U",
        "Ä": "A",
        "ä": "A",
        "à": "A",
        "Ö": "O",
        "ö": "O",
        "ß": "S",
      },
      firstEntries: {},
      glossarListHeight: '100px',
    }
  },
  computed: {
    currentLanguageEntries() {
      const lang = this.$i18n.locale === "en" ? "en-gb" : "de-de"
      return this.entries.filter(item => item.lang === lang)
    },
    letters() {
      return this.createStructure().reduce((acc, bucket) => {
        acc.push(bucket.name)
        return acc
      }, [])
    },
    sortedLettersEntries() {
      if (!this.entries) return []
      const structure = this.createStructure()
      const collator = new Intl.Collator('de-u-co-phonebk')
      const entries = [...this.currentLanguageEntries].sort(({text: a}, {text: b}) => collator.compare(a, b))

      // Bucket sort
      entries.forEach(entry => {
        if (!entry.text) return
        const firstChar = this.getFirstLetter(entry.text)
        const bucket = structure.find(bucket => bucket.name === firstChar) || structure.find(bucket => bucket.name === '#')
        if (bucket.entries.length === 0) {
          entry = {
            ...entry,
            isFirstEntry: true
          }
        }
        bucket.entries.push(entry)
      })

      const result = []
      let entriesBefore = false
      structure.forEach(bucket => {
        if (entriesBefore && bucket.entries.length) {
          result.push({spacer: true})
        }
        result.push(...bucket.entries)

        entriesBefore = !!bucket.entries.length
      })
      return result
    }
  },
  methods: {
    getFirstLetter(str) {
      const firstChar = str.charAt(0).toUpperCase()
      const normalised = this.diacriticsMap[firstChar] || firstChar
      return this.letters.includes(normalised) ? normalised : '#'
    },
    createStructure() {
      return [
        {name: "#", entries: []}, {name: "A", entries: []}, {name: "B", entries: []},
        {name: "C", entries: []}, {name: "D", entries: []}, {name: "E", entries: []}, {name: "F", entries: []},
        {name: "G", entries: []}, {name: "H", entries: []}, {name: "I", entries: []},
        {name: "J", entries: []}, {name: "K", entries: []}, {name: "L", entries: []}, {name: "M", entries: []},
        {name: "N", entries: []}, {name: "O", entries: []}, {name: "P", entries: []}, {name: "Q", entries: []},
        {name: "R", entries: []}, {name: "S", entries: []}, {name: "T", entries: []}, {name: "U", entries: []},
        {name: "V", entries: []}, {name: "W", entries: []}, {name: "X", entries: []}, {name: "Y", entries: []},
        {name: "Z", entries: []}
      ]
    },
    getScrollElement() {
      return this.$el.querySelector('.v-virtual-scroll')
    },

    resize() {
      this.calculateGlossarListHeight()
      this.updateScrollbar()
    },

    findEntryByKey(ref) {
      return this.entries.find((entry) => entry.ref === ref)
    },

    setCurrentEntry(val) {
      this.doClear()
      this.$emit('input', val)
    },

    doClear() {
      this.searchText = ''
      this.message = ['']
    },

    doSearch() {
      if (!this.searchText) {
        return
      }
      const entry = this.findEntryByKey(this.searchText)
      this.setCurrentEntry(entry)
    },
    isActive(ref) {
      return ref === this.value?.ref
    },
    calculateGlossarListHeight() {
      if (this.$refs.autoCompleteRow) {
        let glossarScrollerTop = this.$refs.glossarScroller.$el.getBoundingClientRect().top
        let windowInnerHeight = window.innerHeight
        let height = windowInnerHeight - glossarScrollerTop
        this.glossarListHeight = height + "px"
      }
    },
    searchSelectionChanged(val) {
      if (val !== undefined) {
        this.currentEntry = val
        this.doClear()
        this.$emit('input', val)
      }
    }
  },
  watch: {
    searchText() {
      this.$nextTick(() => {
        this.doSearch()
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../styles/variables.scss";

.entry:not(.activeEntry) {
  font-weight: normal !important;
}

.entry {
  height: 38px;
  min-height: 38px;
  max-height: 38px;
}

.big-letter {
  font-family: $heading-font-family;
  font-size: 45px;
  font-weight: bold;
  line-height: 60px;
  position: absolute;
  top: 0;
}

::v-deep .v-btn, .v-btn__content {
  justify-content: flex-start;
}

::v-deep .v-btn.theme--light .v-btn__content {
  color: $fin-color-primary-light !important;
}

/*Scrollbar invisible*/
.entries-wrapper {
  scrollbar-width: none; /* Firefox */
}

.entries-wrapper::-webkit-scrollbar {
  width: 0;
  background: transparent; /* Chrome/Safari/Webkit */
}

</style>
